import React from 'react';
import './blockTitle.css';


// Компонент заголовка блока с кнопками
const BlockTitle = ({
    title,
    buttons,
}) => {


    return (
        <div className="block-title">
            {title ? <div className="block-title-text">{title}</div> : null}
            <div className="block-title-btn">
                {buttons.map((button, index) => (
                    <div
                        key={index}
                        onClick={button.onClick}
                        className={["button-default", button.type].filter(Boolean).join(" ")}
                    >
                        {button.label}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default BlockTitle;
